import { UserModalContent, UserModalHeader } from '@features/components/UserModalLayout';
import { PropsWithChildren } from 'react';
import { useComposedCustomerByIdQuery } from '@/queries/customer';
import { getRolesFormatted } from '@/utils/helpers';
import { AssignedUserData } from '@/api/apis/case';
import { UserModalSkeleton } from './UserModalSkeleton';

type CustomerModalContentProps = {
  user: AssignedUserData;
  hospitalName?: string;
  hospitalLabel?: string;
  customerId?: string;
  txCenterId?: string;
};

export const CustomerModalContent = ({
  user,
  hospitalName,
  hospitalLabel,
  customerId,
  txCenterId,
}: CustomerModalContentProps & PropsWithChildren) => {
  const { firstName, lastName, email, phone, secondaryPhone, photoPath } = user;
  const { data } = useComposedCustomerByIdQuery(customerId);

  const txCenterLink = data?.customerInTxCenters?.find((link) => link.txCenterId === txCenterId);
  const roles = txCenterLink?.roles ?? [];

  if (!data) return <UserModalSkeleton />;
  return (
    <>
      <UserModalHeader
        firstName={firstName}
        lastName={lastName}
        photo={photoPath}
        userRole={getRolesFormatted(roles) || ''}
      />
      <UserModalContent
        email={email}
        hospitalLabel={hospitalLabel}
        hospitalName={hospitalName}
        primaryPhone={phone}
        secondaryPhone={secondaryPhone}
      />
    </>
  );
};
